"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.APPEND_TRANSCRIPT = exports.CLEAR_TRANSCRIPT = void 0;
var CLEAR_TRANSCRIPT = 'CLEAR_TRANSCRIPT';
exports.CLEAR_TRANSCRIPT = CLEAR_TRANSCRIPT;
var APPEND_TRANSCRIPT = 'APPEND_TRANSCRIPT';
exports.APPEND_TRANSCRIPT = APPEND_TRANSCRIPT;